if (!window.Eurus.loadedScript.has('estimate-shipping-rate.js')) {
  window.Eurus.loadedScript.add('estimate-shipping-rate.js');

  requestAnimationFrame(() => {
    document.addEventListener("alpine:init", () => {
      Alpine.data("xEstimateShipping", (el, single, multiple, noRates) => ({
        countryEl: el.querySelector('.country-select'),
        provinceEl: el.querySelector('.province-select'),
        provinceContainer: el.querySelector('.province-container'),
        zip: el.querySelector('.zip-input'),
        rates: el.querySelector('.rates'),
        errors: el.querySelector('.errors'),

        cart_shipping_zip: '',

        loadingShipping: false,
        rates_heading: '',
        rates_text: '',
        errors_message: '',
        cachedData: [],
        cachedResponse: [],

        load() {
          // aplica país/província default do DOM
          this.setSelectedOption(this.countryEl, this.countryEl?.dataset?.default);

          if (this.provinceEl?.dataset?.default && this.provinceEl.options.length > 0) {
            this.setSelectedOption(this.provinceEl, this.provinceEl.dataset.default);
          }

          this.handleCountryChange();
          this.countryEl?.addEventListener('change', this.handleCountryChange.bind(this));

          // CEP: prioriza localStorage, senão pega do value do input (default_zip do Liquid)
          const storedZip = (localStorage.getItem('cart_shipping_zip') || '').trim();
          const domZip = (this.zip?.value || '').trim();
          this.cart_shipping_zip = storedZip || domZip || '';
        },

        handleCountryChange() {
          if (!this.countryEl || !this.provinceEl) return;

          const selectedOption = this.countryEl.options[this.countryEl.selectedIndex];
          const provinces = JSON.parse(selectedOption.dataset.provinces || "[]");

          Array.from(this.provinceEl.options).forEach((option) => option.remove());

          if (provinces && provinces.length === 0) {
            if (this.provinceContainer) this.provinceContainer.hidden = true;
          } else {
            provinces.forEach((province) => {
              const option = document.createElement('option');
              [option.value, option.innerHTML] = province;
              this.provinceEl.appendChild(option);
            });

            if (this.provinceContainer) this.provinceContainer.hidden = false;
          }
        },

        setSelectedOption(selector, value) {
          if (!selector || value == null) return;

          Array.from(selector.options).forEach((option, index) => {
            if (option.value === value || option.innerHTML === value) {
              selector.selectedIndex = index;
            }
          });
        },

        async submit(e) {
          e?.preventDefault();

          this.errors?.classList.add('hidden');
          this.rates?.classList.add('hidden');

          const zipVal = (this.cart_shipping_zip || this.zip?.value || '').trim();
          const countryVal = this.countryEl?.value || '';
          const provinceVal = this.provinceEl?.value || '';

          const params =
            `shipping_address[zip]=${encodeURIComponent(zipVal)}` +
            `&shipping_address[country]=${encodeURIComponent(countryVal)}` +
            `&shipping_address[province]=${encodeURIComponent(provinceVal)}`;

          if (this.cachedData[params]) {
            if (this.cachedResponse[params]) this.showRates(this.cachedData[params], single, multiple, noRates);
            else this.showErrors(this.cachedData[params]);
            return true;
          }

          this.loadingShipping = true;

          try {
            const response = await fetch(`${Shopify.routes.root}cart/shipping_rates.json?${params}`);
            const data = await response.json();

            if (response.ok) this.showRates(data, single, multiple, noRates);
            else this.showErrors(data);

            this.cachedResponse[params] = response.ok;
            this.cachedData[params] = data;
          } catch (error) {
            console.log(error);
          } finally {
            this.loadingShipping = false;
          }
        },

        // ✅ Extrai prazo APENAS se vier no texto (integração/app)
        // Exemplos suportados:
        // "Normal (Em até 4 dias úteis)"
        // "Normal (4 dias úteis)"
        // "Normal - Em até 4 dias úteis"
        // "Normal | 4 dias úteis"
        // "Normal - 4 a 6 dias úteis"
        extractNameAndDeadline(rate) {
          const rawName = (rate?.name || '').toString().trim();
          const rawDesc = (rate?.description || '').toString().trim();

          const sourceText = rawName + (rawDesc ? ` ${rawDesc}` : '');

          const deadlineRegex = /(em\s+ate\s+)?(\d+\s*(a|-)\s*\d+|\d+)\s+dias?(?:\s+uteis)?/i;
          const match = sourceText.match(deadlineRegex);

          let deadline = '';
          if (match && match[0]) {
            const cleaned = match[0].trim();
            deadline = /^em\s+ate/i.test(cleaned) ? cleaned : `Em até ${cleaned}`;
          }

          let cleanName = rawName;
          if (deadline) {
            cleanName = cleanName
              .replace(/\([^)]*dias?[^)]*\)/ig, '')
              .replace(/[-|–—]\s*(em\s+ate\s+)?[\d\s\-a]+dias?(?:\s+uteis)?/ig, '')
              .replace(/\s{2,}/g, ' ')
              .trim();
          }

          return { name: cleanName || rawName, deadline };
        },

        // ✅ mostra só 2 + botão "Ver tudo"
        showRates(data, single, multiple, noRates) {
          if (!this.rates) return;

          const headingEl = this.rates.querySelector('.rates-heading');

          if (data.shipping_rates && data.shipping_rates.length) {
            this.rates_heading = data.shipping_rates.length === 1 ? single : multiple;
            if (headingEl) headingEl.classList.remove('hidden');

            let rows = '';

            data.shipping_rates.forEach((rate, index) => {
              const price = new Intl.NumberFormat('pt-BR', {
                style: 'currency',
                currency: rate.currency || 'BRL'
              }).format(Number(rate.price));

              const parsed = this.extractNameAndDeadline(rate);

              rows += `
                <div
                  class="eh-rate-row ${index > 0 ? 'eh-rate-row--border' : ''}"
                  data-rate-index="${index}"
                >
                  <div class="eh-rate-left">
                    <div class="eh-rate-name">${parsed.name}</div>
                    ${parsed.deadline ? `<div class="eh-rate-deadline">${parsed.deadline}</div>` : ``}
                  </div>
                  <div class="eh-rate-price">${price}</div>
                </div>
              `;
            });

            const hasMoreThanTwo = data.shipping_rates.length > 2;

            this.rates_text = `
              <div class="eh-rates" data-show-all="0">
                ${rows}
                ${
                  hasMoreThanTwo
                    ? `<button type="button" class="eh-rates-toggle mt-3 text-sm underline underline-offset-2">Ver tudo</button>`
                    : ``
                }
              </div>
            `;

            // aplica o "mostrar 2" depois do x-html renderizar
            this.$nextTick(() => {
              const root = this.rates.querySelector('.eh-rates');
              if (!root) return;

              const btn = root.querySelector('.eh-rates-toggle');
              const allRows = Array.from(root.querySelectorAll('.eh-rate-row'));

              const applyVisibility = () => {
                const showAll = root.getAttribute('data-show-all') === '1';
                allRows.forEach((row) => {
                  const idx = Number(row.getAttribute('data-rate-index') || 0);
                  row.style.display = (showAll || idx < 2) ? '' : 'none';
                });
                if (btn) btn.textContent = showAll ? 'Ver menos' : 'Ver tudo';
              };

              root.setAttribute('data-show-all', '0');
              applyVisibility();

              if (btn) {
                btn.onclick = () => {
                  const current = root.getAttribute('data-show-all') === '1';
                  root.setAttribute('data-show-all', current ? '0' : '1');
                  applyVisibility();
                };
              }
            });

          } else {
            if (headingEl) headingEl.classList.add('hidden');
            this.rates_text = `<p class="no-rate">${noRates}</p>`;
          }

          this.rates.classList.remove('hidden');
        },

        showErrors(data) {
          if (!this.errors) return;

          let errors = '';
          Object.keys(data || {}).forEach((key) => {
            errors += `<li>${data[key]}</li>`;
          });

          this.errors_message = `<ul>${errors}</ul>`;
          this.errors.classList.remove('hidden');
        }
      }));

      Alpine.store('xPopupShipping', { open: false });
    });
  });
}
